import * as React from "react";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Container, DialogContentText, Popover, Stack, Typography } from "@mui/material";

const AvisoPopover =()=>{

const [firstPopoverAnchor, setFirstPopoverAnchor] = React.useState(null);

const handleFirstClick = (event) => {
    setFirstPopoverAnchor(event.currentTarget);
  };
const handleCloseFirstClick = (event) => {
  setFirstPopoverAnchor(null);
};

return(
<div>
<Stack direction="row" alignItems={'center'}>
<DialogContentText>
Por favor, preencha os consumos dos energéticos abaixo (em GJ)
</DialogContentText>
 <HelpOutlineIcon
    onClick={handleFirstClick}
    sx={{
      m: 2,
    }}
  />
  <Popover
    open={Boolean(firstPopoverAnchor)}
    anchorEl={firstPopoverAnchor}
    onClose={handleCloseFirstClick}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
  >
    <Typography sx={{ p: 2 }}>
          <strong>IMPORTANTE!</strong> Os dados energéticos devem ser obrigatoriamente preenchidos em GJ.<br></br>
    Caso você tenha dados em outra unidade, você pode baixar a seguinte calculadora para auxiliá-lo no processo de conversão:
    <br></br>
    <a 
    href='https://venidera.sharepoint.com/:x:/s/IBRAM/EU7Jr_s9V-JMl9RK4BXHUPcBPGgR2J07DTpbdknd8wx6Eg?e=nD3cLi'
    target="_blank"
    >
    Baixe aqui a planilha de conversão
    </a>
    <br></br>
    Observações:
    <br></br>
    - Preencha com 0: caso a informação seja igual a zero para sua empresa. Exemplo: caso não consuma determinado tipo de combustível.
    <br></br>
    - Clique em "NA" caso o campo não seja aplicável à sua empresa.
    </Typography>
  </Popover>
</Stack>
</div>
)
}
export default AvisoPopover